import { render, staticRenderFns } from "./supplierBidDetailsNew1.vue?vue&type=template&id=c2101cc8&scoped=true"
import script from "./supplierBidDetailsNew1.vue?vue&type=script&lang=js"
export * from "./supplierBidDetailsNew1.vue?vue&type=script&lang=js"
import style0 from "./supplierBidDetailsNew1.vue?vue&type=style&index=0&id=c2101cc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2101cc8",
  null
  
)

export default component.exports